const checkUploadStatusType = statusToCheck => (file) => {
  const statusTypeMin = 100 * statusToCheck;
  const statusTypeMax = statusTypeMin + 100;

  const isStatusInRange = file.serviceStatusCode >= statusTypeMin
    && file.serviceStatusCode < statusTypeMax;

  return !isStatusInRange;
};

export default checkUploadStatusType;
